import React from 'react';
import './DonationBanner.css';

const DonationBanner = () => {
  return (
    <div className="donation-banner">
      <div className="donation-content">
        <h2 className="donation-title">
          Support a Smarter Way to Learn – No Ads, Just Words!
        </h2>
        <div className="donation-message-container">
          <p className="donation-message">
            We believe learning should be engaging, effective, and distraction-free.
            <br />
            Join us in building a better way to learn. Every contribution makes a difference!
          </p>
          <a href="https://buymeacoffee.com/thelearningdictionary" target="_blank" rel="noopener noreferrer" className="donate-button">
            Donate now
          </a>
        </div>
      </div>
    </div>
  );
};

export default DonationBanner; 